import type { Publisher } from "@repo/fika-shared/src/loader/publisher-schema.js"
import type { Story } from "@repo/fika-shared/src/loader/story-schema.js"
import { useParams } from "@solidjs/router"
import { createMemo, Show } from "solid-js"
import { useAppContext } from "@/context/app"
import { MainLayout } from "@/designSystem/layouts/mainLayout"
import { Navigation } from "@/designSystem/patterns/navigation"
import { useI18nContext } from "@/i18n/i18n-solid"
import { getTitle } from "@/lib/getTitle"
import { splitUrl } from "@/lib/slug"
import { createPublishersRouter } from "@/routes/publishers-router"
import { StoryDetail, StoryFooter } from "../stories/frame"
import usePublisher from "./use-publisher"

export function PublisherItemStory() {
  const { db } = useAppContext()
  const params = useParams()

  const getStoryId = createMemo(() => splitUrl(params.storyId))
  const getStory = createMemo(() => db.story.get(getStoryId()))
  const getPublisher = usePublisher()

  return (
    <Show when={getPublisher()}>
      {publisher => (
        <Show when={getStory()}>
          {story => <SafeStoryFrame story={story()} publisher={publisher()} />}
        </Show>
      )}
    </Show>
  )
}

function SafeStoryFrame(props: { publisher: Publisher; story: Story }) {
  const { LL } = useI18nContext()
  const publisherTitle = createMemo(() => getTitle(props.publisher.dc_title))
  const title = createMemo(() => getTitle(props.story.dc_title))
  const { paths } = createPublishersRouter()

  const buttons = createMemo(() => {
    return [
      {
        label: LL().common.feeds(),
        href: paths().url,
      } as const,
      {
        label: publisherTitle(),
        href: paths().publisher(props.publisher).url,
      } as const,
    ]
  })

  return (
    <MainLayout
      header={<Navigation hue="indigo" title={title()} buttons={buttons()} />}
      footer={<StoryFooter story={props.story} title={title()} />}
    >
      <StoryDetail story={props.story} />
    </MainLayout>
  )
}
